import React from 'react'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

export const ButtonSecondaryCSS = css`
  background-color: transparent;
  display: inline-block;
  border: 2px solid ${(props) => props.theme.color.secondary};
  text-align: center;
  min-width: 195px;
  & > a,
  & > button {
    color: ${(props) => props.theme.color.secondary};
    padding: 5px 10px;
    width: 100%;
    height: 100%;
    display: block;
  }
`

const StyledButton = styled(motion.span)`
  ${ButtonSecondaryCSS};
`

interface ButtonSecondaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
}

const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonSecondary
